"use client";

import { useEffect } from "react";

export function ScrollAnimateObserver() {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-animate]");

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
      );

      elements.forEach((el) => observer.observe(el));

      return () => observer.disconnect();
    } else {
      elements.forEach((el) => el.classList.add("in"));
    }
  }, []);

  return null;
}
